import { defineRule, configure } from "vee-validate";
import { required, email } from "@vee-validate/rules";
import { parsePhoneNumber } from "awesome-phonenumber";

defineRule("email", email);

defineRule("phone", (value) => {
  if (parsePhoneNumber(value, { regionCode: "US" }).valid) {
    return true;
  } else {
    return "Must be a valid phone number.";
  }
});

defineRule("required", required);

configure({
  generateMessage: (context) => {
    if (context.rule.name === "required") {
      return `${context.field} is required.`;
    }

    return `${context.field} is invalid.`;
  },
});
